import { useCallback, useMemo } from 'react';
import { useQueue } from '../../hooks/useQueue.mjs';
import { logger } from '../../utils/logger.mjs';

let count = 0;
function useToastState({ limit }) {
  const {
    state,
    queue,
    update: updateToast,
    clearQueue
  } = useQueue({
    initialValues: [],
    limit
  });
  const show = useCallback(
    (toast) => {
      const id = toast.id ?? getToastId();
      updateToast((toasts) => {
        const hasSameId = toast.id && toasts.some((n) => n.id === toast.id);
        if (hasSameId) {
          logger.warn(
            `id\uAC00 ${toast.id}\uC778 \uD1A0\uC2A4\uD2B8\uAC00 \uC774\uBBF8 \uC874\uC7AC\uD558\uC5EC \uC0C8\uB86D\uAC8C \uCD94\uAC00\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.`
          );
          return toasts;
        }
        return [...toasts, { ...toast, id }];
      });
      return id;
    },
    [updateToast]
  );
  const update = useCallback(
    (id, toast) => updateToast((toasts) => {
      const toastId = toast.id ?? getToastId();
      const index = toasts.findIndex((n) => n.id === id);
      if (index === -1) {
        return toasts;
      }
      const newToasts = [...toasts];
      newToasts[index] = {
        ...toast,
        id: toastId
      };
      return newToasts;
    }),
    [updateToast]
  );
  const hide = useCallback(
    (id) => updateToast(
      (notifications) => notifications.filter((notification) => {
        if (notification.id === id) {
          notification.onClose?.(notification);
          return false;
        }
        return true;
      })
    ),
    [updateToast]
  );
  const clean = useCallback(() => updateToast(() => []), [updateToast]);
  return useMemo(
    () => ({
      toasts: state,
      queue,
      show,
      update,
      hide,
      clearQueue,
      clean
    }),
    [clean, clearQueue, hide, queue, show, state, update]
  );
}
function getToastId() {
  return `linear-toast-${count++}`;
}

export { useToastState };
//# sourceMappingURL=useToastState.mjs.map
